module.exports = __webpack_public_path__ + "static/img/yaoqing2.49630b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yaoqing2.png
// module id = 1ASI
// module chunks = 24